import React from 'react'
import SystemErrorHandler from '../pageBaseComponents/SystemErrorHandler'
import EventEmitterExResident from '../pageBaseComponents/EventEmitterExResident'
import {NavigateFunction} from 'react-router-dom'

interface ExternalProps {
    eventEmitter: EventEmitterExResident
    navigate: NavigateFunction
}

export interface ResidentPageProps {
    eventEmitter: EventEmitterExResident
}

export const withResidentPageTemplate = <OriginalProps extends {}>(
    ResidentPageWrappedComponent: React.ComponentType<OriginalProps & ResidentPageProps>,
) => {

    type ResultProps = OriginalProps & ExternalProps;

    return class extends React.Component<ResultProps> {
        static displayName: string = `withResidentPageTemplate(${ResidentPageWrappedComponent.displayName})`

        render(): JSX.Element {
            return (
                <>
                    <SystemErrorHandler
                        {...this.props}
                        url={'/resident/error'}
                        loginUrl={'/resident/login'}
                    />
                    <ResidentPageWrappedComponent
                        {...this.props}
                    />
                </>
            )
        }
    }
}
